import React, {useState} from "react";
import { Button, Spinner } from "react-bootstrap";

export default function ButtonWithLoadSpinner(props){
  let [loading, setLoading] = useState(false)
  let {children, onClick, ...rest} = props

  async function clickWrap(){
    setLoading(true)
    setTimeout(async ()=>{
      await props.onClick()
      setLoading(false)
    })
  }
  // console.log('rendering children', children)
  return (
    <Button {...rest} onClick={clickWrap}>
      {loading?(
        <Spinner animation="border" variant={props.variant}  />
      ):[children]}
    </Button>
  )
}